import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';

const ErrorBreakdown = ({ data }) => {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Top Errors</CardTitle>
        <CardDescription>Routes with the highest error counts</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Route</TableHead>
              <TableHead className="text-right">Errors</TableHead>
              <TableHead>Most Common Error</TableHead>
              <TableHead className="text-center">Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((row) => (
              <TableRow key={row.route}>
                <TableCell className="font-mono text-xs">{row.route}</TableCell>
                <TableCell className="text-right tabular-nums font-medium">{row.error_count.toLocaleString()}</TableCell>
                <TableCell className="max-w-[240px] truncate text-muted-foreground text-sm">{row.most_common_error}</TableCell>
                <TableCell className="text-center">
                  <Badge variant={row.most_common_status >= 500 ? 'destructive' : 'secondary'}>{row.most_common_status}</Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default ErrorBreakdown;
